export enum ChangeTypes {
  Update = 'u',
  AddAbove = 'aa',
  AddBelow = 'ab',
  Remove = 'r',
}

export enum UpdateChangeKeys {
  Type = 't',
  DataKey = 'd',
  NewValue = 'n',
  RowId = 'r',
}

export enum RowRemoveChangeKeys {
  Type = 't',
  RowId = 'r',
}

export enum RowAddChangeKeys {
  Type = 't',
  RowId = 'r',
  NewRowId = 'n',
}
